export default __webpack_public_path__ + "static/images/rose_04.png";